import React from 'react';

const SvgPa = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="PA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PA_svg__b" fill="#fff">
        <use xlinkHref="#PA_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M13.333 0H28v9.333H13.333V0z"
        fill="#E52448"
        mask="url(#PA_svg__b)"
      />
      <path
        d="M13.333 9.333V20H0V9.333h13.333zM6.667 5.76L5.099 6.824l.528-1.82L4.13 3.844l1.893-.06L6.667 2l.642 1.782 1.894.06-1.497 1.163.528 1.819z"
        fill="#1367AE"
        mask="url(#PA_svg__b)"
      />
      <path
        fill="#E52448"
        mask="url(#PA_svg__b)"
        d="M20.667 15.76l-1.568 1.064.528-1.82-1.496-1.161 1.893-.06.643-1.783.642 1.782 1.894.06-1.497 1.163.528 1.819z"
      />
    </g>
  </svg>
);

export default SvgPa;
